export default {
      id: "ic_new_bulletin_search-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_new_bulletin_search-usage",
      toString: function () {
        return this.url;
      }
    }